import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles, requireApprovedAgency }) {
  const { user, organization, loading } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-slate-500" data-testid="auth-loading">
        {t("common.loading")}
      </div>
    );
  }

  if (!user) {
    const target = location.pathname.startsWith("/admin") ? "/login" : "/";
    return <Navigate to={target} replace state={{ from: location.pathname }} />;
  }

  if (roles && !roles.includes(user.role)) {
    // Employer trying to visit /marketplace or /marketplace/:id -> send them to their equivalent.
    if (user.role === "employer" && location.pathname.startsWith("/marketplace")) {
      return <Navigate to="/missions/mine" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  if (requireApprovedAgency) {
    if (user.role === "agency" && organization && organization.status !== "active") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
